<template>
  <transition name="modal">
    <div class="test-modal" v-if="visible" @click.self="$emit('close')">
      <div class="modal-content">
        <button type="button" class="close position-absolute" @click="$emit('close')">
          <span aria-hidden="true">&times;</span>
        </button>
        <div
          v-for="(item, idx) in tests"
          :key="idx"
          class="test-row"
          :class="{ selected: selectedIdx === idx }"
          @click="selectRow(idx)"
        >
          <div class="test-image">
            <img :src="item.image" alt="study image">
          </div>
          <div class="test-desc">
            <div class="test-title">{{ item.title }}</div>
            <div class="test-detail">{{ item.desc }}</div>
          </div>
          <button
            v-if="selectedIdx === idx"
            class="go-btn"
            @click.stop="goTest(item.link)"
          >GO</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    visible: Boolean
  },
  data() {
    return {
      selectedIdx: null,
      tests: [
        {
          image: require("@/assets/images/wordlearn.png"),
          title: "Test Your Wordbank",
          desc: "Boost your vocabulary with our interactive word game! Master grocery essential words through spelling races. Track progress, and compete with friends!",
          link: "http://quiz.generalwrite.com"  // 修改为新的路径
        },
        {
          image: require("@/assets/images/ielts-logo.png"),
          title: "IELTS Word Challenge",
          desc: "Master 2000+ high-frequency IELTS words through interactive games! Test your skills with vocabulary flashcards, quizzes, and context-based puzzles. Fun, effective, and designed for band 7+ success!",
          link: "https://your-test-url-2"
        },
        {
          image: require("@/assets/images/clockin-1.jpg"),
          title: "Clock-In Learning (Postgraduate)",
          desc: "Join study squads for daily accountability, compete in vocabulary challenges, and track progress with smart analytics. Our proven \"read-word + motion\" method boosts retention by 40%!",
          link: "https://your-test-url-3"
        },
        {
          image: require("@/assets/images/blog3.jpg"),
          title: "Preliminary & Vantage (For Beginners)",
          desc: "Level up your vocabulary with our beginner-friendly word adventure! Earn stars for correct answers, unlock bonus levels, and track progress!",
          link: "https://your-test-url-4"
        }
      ]
    }
  },
  methods: {
    selectRow(idx) {
      this.selectedIdx = idx;
    },
    goTest(link) {
      let urlToOpen = link;
      if (link.startsWith('http')) {
        // 外部链接
        const token = localStorage.getItem('token');
        if (token) {
          // 检查链接是否已经包含查询参数
          if (urlToOpen.includes('?')) {
            urlToOpen += `&token=${encodeURIComponent(token)}`;
          } else {
            urlToOpen += `?token=${encodeURIComponent(token)}`;
          }
        }
        window.open(urlToOpen, '_blank');
      } else {
        // 内部路由
        this.$router.push(link);
      }
      this.$emit('close'); // 关闭弹窗
    }
  }
}
</script>

<style scoped>
.test-modal {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 10px;
  width: 64%;
  max-width: 800px;
  max-height: 600px;
  position: relative;
}

.close {
  right: 1rem;
  top: 1rem;
  z-index: 1050;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

/* 过渡动画 */
.modal-enter-active, .modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-active .modal-content,
.modal-leave-active .modal-content {
  transition: transform 0.3s ease;
}

.modal-enter, .modal-leave-to {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-to .modal-content {
  transform: translateY(-20px);
}

.modal-enter-to .modal-content,
.modal-leave .modal-content {
  transform: translateY(0);
}
.test-row {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease; /* 修改transition，包含所有属性 */
  padding: 0.5rem;
  border-radius: 5px;
  min-height: 100px;
  border: 2px solid transparent; /* 添加透明边框，防止选中时出现抖动 */
}

.test-row:hover {
  background: #f0f3f2;
}

/* 添加选中状态的样式 */
.test-row.selected {
  border-color: #007bff;
  background: #f0f3f2;
}
.test-image {
  width: 100px;
  height: 120px;
  background: #eee;
  margin-right: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; /* 防止图片溢出 */
}

.test-image img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 确保图片填充整个容器并保持比例 */
}

.test-desc {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 120px; /* 设置描述区域高度与行高一致 */
  padding-right: 60px; /* 为GO按钮预留空间 */
}

.test-title {
  font-weight: bold;
  font-size: 1.25rem; /* 增大标题字号 */
  margin-bottom: 0.5rem;
}

.test-detail {
  color: #666;
  font-size: 0.9rem; /* 缩小描述文字字号 */
  line-height: 1.4;
}
.go-btn {
  position: absolute; /* 使用绝对定位 */
  right: 40px; /* 距离右边距离 */
  width: 50px; /* 固定按钮宽度 */
  height: 50px; /* 固定按钮宽度 */
  background: #007bff;
  color: #fff;
  border: none;
  padding: 0.5rem 0; /* 修改内边距 */
  border-radius: 5px;
  cursor: pointer;
  text-align: center; /* 文字居中 */
}
.close-btn {
  margin-top: 1rem;
  float: right;
  padding: 0.5rem 1rem;
  background: #f0f0f0;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.close-btn:hover {
  background: #e0e0e0;
}
</style>